/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Injectable } from '@angular/core';

import { DigitalData } from '@digital-platform/rs-analytics/domain';

interface WindowObj extends Window {
  digitalData?: DigitalData;
  _satellite?: {
    track: (trackId: string) => void;
  };
}

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  get nativeWindow(): WindowObj {
    //@ts-ignore
    return window ? window : {};
  }
}
